export namespace MainPageConfig {

  export interface IMainPageConfig {
    entity_id: string;
    title: string;
    description: string;
    banner: string;
    content: MainPageBlocks[];
  }

  export type MainPageBlocks = IImage | IText | ISponsors | IKeyWords | IThemes;

  export enum PageBlockTypes {
    COMBI_PLAYER = 'combi_player',
    QUOTE = 'quote',
    FILMS = 'films',
    CUSTOM_VIDEO = 'custom_video',
    GALLERY = 'gallery',
    IMAGE = 'image',
    TEXT = 'text',
    FILMS_PLAYLIST = 'film_playlist',
    SPONSORS = 'sponsors',
    THEMES = 'themes',
    KEYWORDS = 'keyWords'
  }

  export interface IText {
    type: MainPageConfig.PageBlockTypes;
    showInScrollNav: boolean;
    text: {
      title: string;
      text: string;
      button: IButton;
    };
  }

  export interface IImage {
    type: MainPageConfig.PageBlockTypes;
    showInScrollNav: boolean;
    image: {
      title: string;
      text: string;
      image: string;
      link: IButton
    }
  }

  export interface IButton {
    link_text?: string;
    text?: string;
    link_url?: string;
    url?: string;
  }

  export interface ISponsors {
    type: MainPageConfig.PageBlockTypes;
    showInScrollNav: boolean;
    sponsors: ISponsor[];
  }

  export interface ISponsor {
    id: string;
    sponsor_logo: string;
    sponsor_link: string;
  }

  export interface IThemes {
    type: PageBlockTypes;
    showInScrollNav: boolean;
    themes: {
      title: string;
      text: string;
      themes: ITheme[];
      button: IButton;
    }
  }

  export interface ITheme {
    entity_id: string;
    name: string;
    description: string;
    illustration: string;
    orientation: string;
    count: number;
    total_duration: {
      hours: number;
      minutes: number;
    }
  }

  export interface IKeyWords {
    type: PageBlockTypes;
    showInScrollNav: boolean;
    title: string;
    text: string;
    keyWords: IKeyWord[];
    button: IButton;
  }

  export interface IKeyWord {
    entity_id: string;
    keyword: string;
    random_field: string;
  }
}
